<template>
    <s-data-centers-local v-show="isAvailable" v-bind="content" />
</template>

<script>
import SDataCentersLocal from '@core/slices/pages/data-centers-local/data-centers-local.vue';
import mixin from '../components/mixin.js';

export default {
    name: 'SMainPageDataCentersLocal',
    components: {
        SDataCentersLocal,
    },
    mixins: [mixin],
    props: {
        content: {
            type: Object,
            default: null,
        },
    },
};
</script>
<style lang="postcss" scoped>
.s-data-centers-local {
    &:deep(.a-slice-header__title),
    &:deep(.a-slice-header__lead),
    &:deep(.a-slice-header__body-text) {
        text-align: center;

        @media (--viewport-desktop) {
            text-align: left;
        }
    }
}
</style>
